import { translate } from "@kaltura/mediaspace-shared-utils";
import { PreviewEmbed } from "@kaltura/mediaspace-shared-embed";
import { PlayerContainer, StyledInnedContainer } from "./StyleComponents";

interface KalturaYouTubePlayerProps {
    youtubeId: string;
    title?: string;
    partnerId: number;
    uiconfId?: string;
    cdnUrl?: string;
}

/**
 * KalturaYouTubePlayer component
 *
 * This component is a wrapper around PreviewEmbed that handles YouTube videos.
 * It extracts the YouTube ID from the URL and passes it to PreviewEmbed.
 */
const KalturaYouTubePlayer: React.FC<KalturaYouTubePlayerProps> = ({
    youtubeId,
    title = translate("YouTube Video"),
    partnerId,
    uiconfId,
    cdnUrl,
}) => {
    // Use the PreviewEmbed component with youtubeId
    return (
        <PlayerContainer>
            <StyledInnedContainer>
                <PreviewEmbed
                    partnerId={partnerId}
                    uiConfId={Number(uiconfId)}
                    youtubeId={youtubeId}
                    title={title}
                    width="100%"
                    height="100%"
                    cdnUrl={cdnUrl}
                />
            </StyledInnedContainer>
        </PlayerContainer>
    );
};

export default KalturaYouTubePlayer;
